import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectMenu:{
      index:0,
      path:'/index'
    }
  },
  getters: {
  },
  mutations: {
    // SET_MENU: (state, data) => state.selectMenu = data,
  },
  actions: {
    // clickMenu({ commit }, obj){
    //   commit('SET_MENU', obj)
    // }
  },
  modules: {
  }
})
